import React from 'react';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const ColorButton = withStyles(theme => ({
  root: {
    backgroundColor: "#7eccf0",
    '&:hover': {
      backgroundColor: "#50baeb",
    },
  },
}))(Button);

const Link = props => (
  <ColorButton variant="contained" style={{
    marginTop: ".25rem ",
    marginBottom: ".25rem",
    marginLeft: ".25rem",
    marginRight: ".25rem",
  }} onClick={() => window.open(props.url)} {...props}>{props.text}</ColorButton>
);

export default Link;


// WEBPACK FOOTER //
// ./src/pages/Link.js